import { render } from "./Statement_Processing.vue?vue&type=template&id=83e44578&scoped=true"
import script from "./Statement_Processing.vue?vue&type=script&lang=js"
export * from "./Statement_Processing.vue?vue&type=script&lang=js"

import "./Statement_Processing.vue?vue&type=style&index=0&id=83e44578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83e44578"]])

export default __exports__